var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isNowFreezePeriod)?_c('WarningBanner',{attrs:{"message":_vm.freezePeriodMessage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }